/**
 * user.model.ts
 * Copyright (c) 2016 Taillight LLC
 */
import {BaseModel} from "./base.model";

export class Claim {
    constructor (src) {
        this.Type = src.Type;
        this.Value = src.Value.replace('&', ' and ');
    }
    Type: string;
    Value: string;
}

export class MyRistkenLink {
    Name: string;
    UserName: string;
    ApplicationId: string;
    ApplicationName: string;
}
export class MyRistken {
    Id: number;
    MyRistkenLinks: Array<MyRistkenLink>;
}

export class UserAccount extends BaseModel {
    FirstName:string;
    LastName:string;
    Email:string;
    UserName:string;
    PrimaryProviderId: string;
    IsLockedOut: boolean;
    ForcePasswordChange: boolean;
    Password: string;
    PasswordNotMapped: string;
    LastLogin: string;
    LastFailedLogin: string;
    PasswordLastChanged:string;
    FailedLoginCount:number;
    IsAccountVerified:boolean;
    VerificationKey: string;
    VerificationKeySent:string;
    Created: string;
    LastUpdated: string;
    PasswordExpireDate: string;
    BeginAccessPeriod: string;
    EndAccessPeriod: string;
    Claims: Array<Claim>;
    MyRistken: MyRistken;
    //Dealerships: Array<DealershipModel>;
    //ApplicationSettings: Array<ApplicationSettingsModel>;
    //HierarchyLeafs: Array<HierarchyLeafModel>;
}
